import React from 'react';

import { Button } from 'reactstrap';
import AbonementCost from './AbonementCost';

import './style.css';

function AbonementCard(props) {
  const { title, parkingPermit, parkingPermitCode, parkingPermitDesc, /*zones,*/ cost, onClick, parkingPermitType } = props;

  function handleClick() {
    onClick({ parkingPermitCode, parkingPermit, cost, parkingPermitType });
  }

  return (
    <div className="abonement">
      <div className="abonement__title">{title}</div>
      <AbonementCost cost={cost} />
      <div className="abonement__descr">
          {/*
            <div className="abonement__zones">Зоны действия</div>
            <div className="abonement__zone">{zones}</div>
          */}
          { parkingPermitDesc && <div className="abonement__descr--text">{parkingPermitDesc}</div>}
      </div>
      <Button className="abonement__pay" color="primary" onClick={handleClick}>
        Оплатить
      </Button>
    </div>
  );
}

AbonementCard.defaultProps = {
  title: '',
  parkingPermit: '',
  parkingPermitCode: '',
  parkingPermitType: '',
  zone: 0,
  cost: 0
};

export default AbonementCard;
